<template>
  <div class="user-info-recharge-list-wrapper">
    <display-navigation title="充值记录" path="user_info" />
    <van-list
      finished-text="没有更多了"
      error-text="加载失败，点击重试"
      :loading="loading"
      :error.sync="error"
      :finished="finished"
      :immediate-check="false"
      @load="handleLoad"
    >
      <van-cell-group
        v-for="(item, index) of rechargeList"
        class="recharge-item"
        :key="index"
      >
        <van-cell title="订单号">{{ item.ordersn }}</van-cell>
        <van-cell title="充值金额">￥{{ item.recharge_price }}</van-cell>
        <van-cell title="赠送金额">￥{{ item.largess_price }}</van-cell>
        <van-cell title="余额">￥{{ item.credit2 }}</van-cell>
        <van-cell title="充值时间">{{
          new Date(item.createtime * 1000).toLocaleString()
        }}</van-cell>
        <van-cell title="订单状态">
          <van-tag :type="payStatusTypes[item.status].type">
            {{ payStatusTypes[item.status].title }}
          </van-tag>
        </van-cell>
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { getRechargeList } from '../../../api/api-user';
import DisplayNavigation from '../../../components/DisplayNavigation';

const payStatusTypes = {
  0: { title: '未付款', type: 'danger' },
  1: { title: '已付款', type: 'success' },
};

export default {
  components: {
    DisplayNavigation,
  },
  data() {
    return {
      page: 1,
      error: false,
      loading: false,
      finished: false,
      rechargeList: [],
      payStatusTypes,
    };
  },
  created() {
    this.handleLoad();
  },
  methods: {
    async handleLoad() {
      this.error = false;
      this.loading = true;
      const { page } = this;
      try {
        const { count, list } = await getRechargeList({ page });
        if (!list) throw new Error();
        this.page += 1;
        this.rechargeList = [...this.rechargeList, ...list];
        if (count <= this.rechargeList.length) this.finished = true;
      } catch {
        this.error = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-recharge-list-wrapper {
  margin-bottom: 50px;
  .recharge-item {
    margin: 8px 0;
    /deep/.van-cell__value {
      overflow: visible;
    }
  }
}
</style>
